module.exports = __webpack_public_path__ + "static/media/logo_sample.7c7f0c0b.png";